import { tv } from 'tailwind-variants';

export const toastStyles = tv({
  slots: {
    wrapper: 'flex items-center gap-3 p-4 rounded-lg bg-popover border-none shadow-md',
    icon: 'text-2xl',
    content: 'flex flex-col gap-1 flex-1',
    title: 'text-base text-fg font-semibold',
    description: 'text-fg-muted text-base whitespace-pre-line',
  },
  variants: {
    severity: {
      info: '',
      success: '',
      warn: '',
      error: '',
      neutral: '',
    },
  },
  compoundVariants: [
    {
      severity: 'info',
      class: {
        icon: 'text-info',
      },
    },
    {
      severity: 'success',
      class: {
        icon: 'text-success',
      },
    },
    {
      severity: 'warn',
      class: {
        icon: 'text-warning',
      },
    },
    {
      severity: 'error',
      class: {
        icon: 'text-danger',
      },
    },
    {
      severity: 'neutral',
      class: {
        color: 'text-secondary',
      },
    },
  ],
  defaultVariants: {
    severity: 'success',
  },
});
